import styled from '@emotion/styled';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  margin-top: 24px;
  box-sizing: border-box;
`;

export const StyledActionButtonContainer = styled.div`
  margin-bottom: 24px;

  button {
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;

export const DetailViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;
